import {defineStore} from 'pinia';
import { AxiosRequestConfig } from "axios";
import handleTeacherError from "@/util/handle_teacher_error";
import apiRequest from '@/util/api-request';


export const useHomeworkStore = defineStore('teacherHomeworkStore', {
  // actions
  actions: {
    async fetchWorks(params) {
      try {
        // FIXME: 現状の url 設定だと works/?work_ids[0]=96&work_ids[]=96 のようになるため見直す
        const config: AxiosRequestConfig = {
          method: "get",
          url: `/teacher/api/homework/works/?${params.work_ids.map((n, index) => `work_ids[${index}]=${n}`).join('&')}`,
          headers: {
            'Content-Type': 'application/json',
          },
          params: params
        };
        const works = await apiRequest(config);
        return works.data.works
      } catch (e) {
        handleTeacherError(e)
      }
    },
    async fetchHomeworkList(params) {
      try {
        const config: AxiosRequestConfig = {
          method: "get",
          url: `/teacher/api/homeworks/`,
          headers: {
            'Content-Type': 'application/json',
          },
          params: params
        };
        const response = await apiRequest(config);
        return response.data.homeworks
      } catch (e) {
        handleTeacherError(e)
      }
    },
    async fetchHomework(id) {
      try {
        const config: AxiosRequestConfig = {
          method: "get",
          url: `/teacher/api/homework/${id}/`,
          headers: {
            'Content-Type': 'application/json',
          },
        };
        const HomeworkResult = await apiRequest(config);
        return HomeworkResult.data
      } catch (e) {
        handleTeacherError(e)
      }
    },
    async fetchHomeworkAdd(payload) {
      try {
        const config: AxiosRequestConfig = {
          method: "post",
          url: "/teacher/api/homework/add/",
          data: payload
        };
        const HomeworkAddResult = await apiRequest(config);
        return HomeworkAddResult.data
      } catch (e) {
        handleTeacherError(e)
      }
    },
    async fetchHomeworkUpdate({
      homeworkId,
      classroom_uuids,
      name,
      message,
      question_set_ids,
      start_datetime,
      end_datetime,
      achievement_condition,
      relearning_required
    }) {
      try {
        const config: AxiosRequestConfig = {
          method: "patch",
          url: `/teacher/api/homework/${homeworkId}/edit/`,
          data: {
            classroom_uuids: classroom_uuids,
            name: name,
            message: message,
            question_set_ids: question_set_ids,
            start_datetime: start_datetime,
            end_datetime: end_datetime,
            achievement_condition: achievement_condition,
            relearning_required: relearning_required,
          }
        };
        const HomeworkUpdateResult = await apiRequest(config);
        return HomeworkUpdateResult.data
      } catch (e) {
        handleTeacherError(e)
      }
    },
    async fetchHomeworkDelete(id) {
      try {
        const config: AxiosRequestConfig = {
          method: "delete",
          url: `/teacher/api/homework/${id}/delete/`,
        };
        const HomeworkAddResult = await apiRequest(config);
        return HomeworkAddResult.data
      } catch (e) {
        handleTeacherError(e)
      }
    },
    async fetchHomeworkProgress({homeworkId, status=null, classroom_uuids=null}) {
      try {
        const config: AxiosRequestConfig = {
          method: "get",
          url: `/teacher/api/homework/${homeworkId}/progress/`,
          headers: {
            'Content-Type': 'application/json',
          },
          params: {
            status: status,
            classroom_uuid: classroom_uuids,
          }
        };
        const response = await apiRequest(config);
        return response.data
      } catch (e) {
        handleTeacherError(e)
      }
    },
    async fetchHomeworkClassrooms(homeworkId) {
      try {
        const config: AxiosRequestConfig = {
          method: "get",
          url: `/teacher/api/homework/${homeworkId}/classrooms/`,
          headers: {
            'Content-Type': 'application/json',
          },
        };
        const response = await apiRequest(config);
        return response.data
      } catch (e) {
        handleTeacherError(e)
      }
    },
  }
})